import PicklistMetadata from "../PicklistMetadata";

// The type picker on "Raise change order".
//
// DISPLAYS Name. Unlike a relationship type -- where the reader stands on one end and wants the
// phrasing from there -- a change order type has one name and it is the administrator's label:
// "Engineering Change Order".
//
// BOUNDED AND SHORT. A tenant defines a handful of kinds, so this is an ordinary dropdown rather
// than a long-list chooser.
class ChangeOrderTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ChangeOrderType";
        this.bounded = true;
        this.enterpriseComponent = "ChangeOrderType";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default ChangeOrderTypePicklistMetadata;
